import { AxiosConfigExplore } from "Explore/Config/AxiosConfig";

export const getSavedViews = () => {
  const axios = AxiosConfigExplore();
  return axios.get("/collaborations/saved-views").then(r => r.data);
};

export const createSavedView = (payload) => {
  const axios = AxiosConfigExplore();
  return axios.post("/collaborations/saved-views", payload).then(r => r.data);
};

export const updateSavedView = (id, payload) => {
  const axios = AxiosConfigExplore();
  return axios.patch(`/collaborations/saved-views/${id}`, payload).then(r => r.data);
};

export const deleteSavedView = (id) => {
  const axios = AxiosConfigExplore();
  return axios.delete(`/collaborations/saved-views/${id}`).then(r => r.data);
};
